var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule-footer footer flex-row no-flex"},[_vm._t("inputs"),_vm._v(" "),_c('div',{staticClass:"actions clear vertically-spaced"},[_c('div',{staticClass:"main-options float-right"},[_vm._t("default")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }